import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'yt-xchange',
  templateUrl: './yt-xchange.component.html'
})
export class YtXchangeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
